import React from "react";
import moment from "moment";
import "./FirstMonthAssessmentForm.css";
import { Input, Row, Col, Radio, Button } from "antd";
import { SendOutlined } from "@ant-design/icons";
import headerAssessmentEN from "../../assets/images/firstMonthAssessmentEN.png";
import headerAssessmentPT from "../../assets/images/firstMonthAssessmentPT.png";
import AdnThankYouComponent from "../common/adnThankYouComponent/AdnThankYouComponent";

const date = moment().format("DD-MM-yyyy");
const { TextArea } = Input;

export default function FirstMonthAssessmentForm({
  employee,
  firstMonthAssessmentQuestions,
  invalidToken,
  values,
  onChange,
  handleFinish,
  messageError1,
  messageError2,
}) {
  return (
    <>
      {invalidToken === true && (
        <AdnThankYouComponent isPTLanguage={!employee.isEmailEnglishLanguage} />
      )}
      {invalidToken === false && (
        <div className="first-month-assessment-container">
          {employee.isEmailEnglishLanguage ? (
            <div className="header">
              <img className="headerImage" src={headerAssessmentEN} alt="" />
            </div>
          ) : (
            <div className="header">
              <img className="headerImage" src={headerAssessmentPT} alt="" />
            </div>
          )}

          <Row gutter={16} className="assessment-data">
            <Col
              xs={24}
              sm={24}
              md={12}
              lg={16}
              xl={16}
              xxl={16}
              className="assessmentEmployee-col"
            >
              {employee.employeeName && (
                <label className="assessmentEmployee">
                  {employee.isEmailEnglishLanguage
                    ? "Name :    " + employee.employeeName
                    : "Nome :    " + employee.employeeName}
                </label>
              )}
            </Col>
            <Col
              xs={24}
              sm={24}
              md={12}
              lg={8}
              xl={8}
              xxl={8}
              className="assessmentEmployee-col"
            >
              {employee.admissionDate && (
                <label className="assessmentEmployee">
                  {employee.isEmailEnglishLanguage
                    ? "Admission Date :    " + employee.admissionDate
                    : "Data admissão :    " + employee.admissionDate}
                </label>
              )}
            </Col>
            <Col
              xs={24}
              sm={24}
              md={12}
              lg={16}
              xl={16}
              xxl={16}
              className="assessmentEmployee-col"
            >
              {employee.managerName && (
                <label className="assessmentEmployee">
                  {employee.isEmailEnglishLanguage
                    ? "Name of person in charge :   " + employee.managerName
                    : "Nome do(a) responsável :   " + employee.managerName}
                </label>
              )}
            </Col>
            <Col
              xs={24}
              sm={24}
              md={12}
              lg={8}
              xl={8}
              xxl={8}
              className="assessmentEmployee-col"
            >
              {employee.employeeName && (
                <label className="assessmentEmployee">
                  {employee.isEmailEnglishLanguage
                    ? "Assessment Date :   " + date
                    : "Data avaliação :    " + date}
                </label>
              )}
            </Col>
          </Row>

          <Row className="assessment-question-container">
            <Col xs={24}>
              <Row className="assessmentQuestion">
                {firstMonthAssessmentQuestions[0] &&
                  firstMonthAssessmentQuestions[0]
                    .firstMonthAssessmentQuestionName}
              </Row>
              <Row gutter={16} className="assessment-question-group">
                {/*Title*/}
                <Col xs={24} sm={24} md={12} lg={16} xl={16} xxl={16}>
                  <Row className="assessmentSatisfaction">
                    <label>
                      {employee.isEmailEnglishLanguage
                        ? "Satisfaction With..."
                        : "Satisfação com..."}
                    </label>
                  </Row>
                </Col>
                <Col xs={24} sm={24} md={12} lg={8} xl={8} xxl={8}>
                  <Row className="levelOfSatisfaction">
                    <label>
                      {employee.isEmailEnglishLanguage
                        ? "Level of satisfaction..."
                        : "Grau de satisfação..."}
                    </label>
                  </Row>
                </Col>

                {/*Question on position 3*/}
                <Col xs={24} sm={24} md={12} lg={16} xl={16} xxl={16}>
                  <Row className="assessmentSubQuestion">
                    {firstMonthAssessmentQuestions[0] &&
                      firstMonthAssessmentQuestions[3]
                        .firstMonthAssessmentQuestionName}
                  </Row>
                </Col>
                <Col xs={24} sm={24} md={12} lg={8} xl={8} xxl={8}>
                  <Row className="response">
                    <Radio.Group
                      onChange={(e) => onChange(e, 3)}
                      value={values[3]}
                    >
                      <Radio value={1}>1</Radio>
                      <Radio value={2}>2</Radio>
                      <Radio value={3}>3</Radio>
                      <Radio value={4}>4</Radio>
                      <Radio value={5}>5</Radio>
                    </Radio.Group>
                  </Row>
                </Col>

                {/*Question on position 4*/}
                <Col xs={24} sm={24} md={12} lg={16} xl={16} xxl={16}>
                  <Row className="assessmentSubQuestion">
                    {firstMonthAssessmentQuestions[0] &&
                      firstMonthAssessmentQuestions[4]
                        .firstMonthAssessmentQuestionName}
                  </Row>
                </Col>
                <Col xs={24} sm={24} md={12} lg={8} xl={8} xxl={8}>
                  <Row className="response">
                    <Radio.Group
                      onChange={(e) => onChange(e, 4)}
                      value={values[4]}
                    >
                      <Radio value={1}>1</Radio>
                      <Radio value={2}>2</Radio>
                      <Radio value={3}>3</Radio>
                      <Radio value={4}>4</Radio>
                      <Radio value={5}>5</Radio>
                    </Radio.Group>
                  </Row>
                </Col>

                {/*Question on position 5*/}
                <Col xs={24} sm={24} md={12} lg={16} xl={16} xxl={16}>
                  <Row className="assessmentSubQuestion">
                    {firstMonthAssessmentQuestions[0] &&
                      firstMonthAssessmentQuestions[5]
                        .firstMonthAssessmentQuestionName}
                  </Row>
                </Col>
                <Col xs={24} sm={24} md={12} lg={8} xl={8} xxl={8}>
                  <Row className="response">
                    <Radio.Group
                      onChange={(e) => onChange(e, 5)}
                      value={values[5]}
                    >
                      <Radio value={1}>1</Radio>
                      <Radio value={2}>2</Radio>
                      <Radio value={3}>3</Radio>
                      <Radio value={4}>4</Radio>
                      <Radio value={5}>5</Radio>
                    </Radio.Group>
                  </Row>
                </Col>

                {/*Question on position 6*/}
                <Col xs={24} sm={24} md={12} lg={16} xl={16} xxl={16}>
                  <Row className="assessmentSubQuestion">
                    {firstMonthAssessmentQuestions[0] &&
                      firstMonthAssessmentQuestions[6]
                        .firstMonthAssessmentQuestionName}
                  </Row>
                </Col>
                <Col xs={24} sm={24} md={12} lg={8} xl={8} xxl={8}>
                  <Row className="response">
                    <Radio.Group
                      onChange={(e) => onChange(e, 6)}
                      value={values[6]}
                    >
                      <Radio value={1}>1</Radio>
                      <Radio value={2}>2</Radio>
                      <Radio value={3}>3</Radio>
                      <Radio value={4}>4</Radio>
                      <Radio value={5}>5</Radio>
                    </Radio.Group>
                  </Row>
                </Col>

                {/*Question on position 7*/}
                <Col xs={24} sm={24} md={12} lg={16} xl={16} xxl={16}>
                  <Row className="assessmentSubQuestion">
                    {firstMonthAssessmentQuestions[0] &&
                      firstMonthAssessmentQuestions[7]
                        .firstMonthAssessmentQuestionName}
                  </Row>
                </Col>
                <Col xs={24} sm={24} md={12} lg={8} xl={8} xxl={8}>
                  <Row className="response">
                    <Radio.Group
                      onChange={(e) => onChange(e, 7)}
                      value={values[7]}
                    >
                      <Radio value={1}>1</Radio>
                      <Radio value={2}>2</Radio>
                      <Radio value={3}>3</Radio>
                      <Radio value={4}>4</Radio>
                      <Radio value={5}>5</Radio>
                    </Radio.Group>
                  </Row>
                </Col>

                {/*Error*/}
                <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
                  <Row className="assessmentErrorMessage" justify="end">
                    {messageError1 && <p>Please fill out all questions!</p>}
                  </Row>
                </Col>

                {/*Caption*/}
                <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
                  <Row className="assessmentLegend">
                    {employee.isEmailEnglishLanguage
                      ? "1 = Very Dissatisfied, 2 = Dissatisfied, 3 = Not Very Satisfied, 4 = Satisfied and 5 = Very Satisfied."
                      : "1 = Muito Insatisfeito, 2 = Insatisfeito, 3 = Pouco Satisfeito, 4 = Satisfeito e 5 = Muito Satisfeito."}
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>

          <Row className="assessment-question-container">
            <Col xs={24}>
              <Row className="assessmentQuestion">
                {firstMonthAssessmentQuestions[0] &&
                  firstMonthAssessmentQuestions[1]
                    .firstMonthAssessmentQuestionName}
              </Row>
              <Row gutter={16} className="assessment-question-group">
                {/*Title*/}
                <Col xs={24} sm={24} md={12} lg={16} xl={16} xxl={16}>
                  <Row className="assessmentSatisfaction">
                    <label>
                      {employee.isEmailEnglishLanguage
                        ? "Satisfaction With..."
                        : "Satisfação com..."}
                    </label>
                  </Row>
                </Col>
                <Col xs={24} sm={24} md={12} lg={8} xl={8} xxl={8}>
                  <Row className="levelOfSatisfaction">
                    <label>
                      {employee.isEmailEnglishLanguage
                        ? "Level of satisfaction..."
                        : "Grau de satisfação..."}
                    </label>
                  </Row>
                </Col>

                {/*Question on position 8*/}
                <Col xs={24} sm={24} md={12} lg={16} xl={16} xxl={16}>
                  <Row className="assessmentSubQuestion">
                    {firstMonthAssessmentQuestions[0] &&
                      firstMonthAssessmentQuestions[8]
                        .firstMonthAssessmentQuestionName}
                  </Row>
                </Col>
                <Col xs={24} sm={24} md={12} lg={8} xl={8} xxl={8}>
                  <Row className="response">
                    <Radio.Group
                      onChange={(e) => onChange(e, 8)}
                      value={values[8]}
                    >
                      <Radio value={1}>1</Radio>
                      <Radio value={2}>2</Radio>
                      <Radio value={3}>3</Radio>
                      <Radio value={4}>4</Radio>
                      <Radio value={5}>5</Radio>
                    </Radio.Group>
                  </Row>
                </Col>

                {/*Question on position 9*/}
                <Col xs={24} sm={24} md={12} lg={16} xl={16} xxl={16}>
                  <Row className="assessmentSubQuestion">
                    {firstMonthAssessmentQuestions[0] &&
                      firstMonthAssessmentQuestions[9]
                        .firstMonthAssessmentQuestionName}
                  </Row>
                </Col>
                <Col xs={24} sm={24} md={12} lg={8} xl={8} xxl={8}>
                  <Row className="response">
                    <Radio.Group
                      onChange={(e) => onChange(e, 9)}
                      value={values[9]}
                    >
                      <Radio value={1}>1</Radio>
                      <Radio value={2}>2</Radio>
                      <Radio value={3}>3</Radio>
                      <Radio value={4}>4</Radio>
                      <Radio value={5}>5</Radio>
                    </Radio.Group>
                  </Row>
                </Col>

                {/*Question on position 10*/}
                <Col xs={24} sm={24} md={12} lg={16} xl={16} xxl={16}>
                  <Row className="assessmentSubQuestion">
                    {firstMonthAssessmentQuestions[0] &&
                      firstMonthAssessmentQuestions[10]
                        .firstMonthAssessmentQuestionName}
                  </Row>
                </Col>
                <Col xs={24} sm={24} md={12} lg={8} xl={8} xxl={8}>
                  <Row className="response">
                    <Radio.Group
                      onChange={(e) => onChange(e, 10)}
                      value={values[10]}
                    >
                      <Radio value={1}>1</Radio>
                      <Radio value={2}>2</Radio>
                      <Radio value={3}>3</Radio>
                      <Radio value={4}>4</Radio>
                      <Radio value={5}>5</Radio>
                    </Radio.Group>
                  </Row>
                </Col>

                {/*Question on position 11*/}
                <Col xs={24} sm={24} md={12} lg={16} xl={16} xxl={16}>
                  <Row className="assessmentSubQuestion">
                    {firstMonthAssessmentQuestions[0] &&
                      firstMonthAssessmentQuestions[11]
                        .firstMonthAssessmentQuestionName}
                  </Row>
                </Col>
                <Col xs={24} sm={24} md={12} lg={8} xl={8} xxl={8}>
                  <Row className="response">
                    <Radio.Group
                      onChange={(e) => onChange(e, 11)}
                      value={values[11]}
                    >
                      <Radio value={1}>1</Radio>
                      <Radio value={2}>2</Radio>
                      <Radio value={3}>3</Radio>
                      <Radio value={4}>4</Radio>
                      <Radio value={5}>5</Radio>
                    </Radio.Group>
                  </Row>
                </Col>

                {/*Error*/}
                <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
                  <Row className="assessmentErrorMessage" justify="end">
                    {messageError2 && <p>Please fill out all questions!</p>}
                  </Row>
                </Col>

                {/*Caption*/}
                <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
                  <Row className="assessmentLegend">
                    {employee.isEmailEnglishLanguage
                      ? "1 = Very Dissatisfied, 2 = Dissatisfied, 3 = Not Very Satisfied, 4 = Satisfied and 5 = Very Satisfied."
                      : "1 = Muito Insatisfeito, 2 = Insatisfeito, 3 = Pouco Satisfeito, 4 = Satisfeito e 5 = Muito Satisfeito."}
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>

          <Row className="assessment-question-container">
            <Col xs={24}>
              <Row className="assessmentQuestion">
                {firstMonthAssessmentQuestions[0] &&
                  firstMonthAssessmentQuestions[2]
                    .firstMonthAssessmentQuestionName}
              </Row>
              <Row className="assessment-question-group">
                {/*Text Area*/}
                <Col xs={24} className="assessment-text-question">
                  <TextArea
                    id="assessmentSugestions"
                    autoSize={{ minRows: 10, maxRows: 10 }}
                    onChange={(e) => onChange(e, 2)}
                    placeholder={
                      employee.isEmailEnglishLanguage
                        ? "Write here your sugestions..."
                        : "Escreve aqui as tuas sugestões..."
                    }
                  />
                </Col>
                <Col xs={24}>
                  <label className="assessmentLegend">
                    <b>
                      {employee.isEmailEnglishLanguage
                        ? "*We stress that if you have any questions you can contact your manager or someone from the Human Capital Team"
                        : "*Reforçamos que para qualquer dúvida ou questão que tenhas poderás entrar em contacto com o/a teu/tua manager ou alguém da equipa de Recursos Humanos."}
                    </b>
                  </label>
                </Col>
              </Row>
            </Col>
          </Row>

          <Row className="button-row">
            <Col xs={24} sm={12} md={8} lg={8} xl={4} xxl={4}>
              <Button
                className="adn-primary-button assessment-button"
                type="primary"
                onClick={() => handleFinish()}
              >
                <SendOutlined />
                {employee.isEmailEnglishLanguage ? "Send" : "Enviar"}
              </Button>
            </Col>
          </Row>

          <Row justify="center">
            <label className="assessment-policy">
              {employee.isEmailEnglishLanguage
                ? "©Adentis. All rights reserved"
                : "©Adentis. Todos os direitos reservados"}
            </label>
          </Row>

          {/* {employee.isEmailEnglishLanguage ? (
            <div className="assessmentEmployee">
              {employee.employeeName && (
                <TextArea
                  id="employeeName"
                  autoSize={{ minRows: 1, maxRows: 1 }}
                  defaultValue={"Name :    " + employee.employeeName}
                  disabled={true}
                />
              )}
              {employee.admissionDate && (
                <TextArea
                  id="admissionDate"
                  autoSize={{ minRows: 1, maxRows: 1 }}
                  defaultValue={"Admission Date :    " + employee.admissionDate}
                  disabled={true}
                />
              )}
              <div>
                <br />
              </div>
              {employee.managerName && (
                <TextArea
                  id="employeeManager"
                  autoSize={{ minRows: 1, maxRows: 1 }}
                  defaultValue={
                    "Name of person in charge :   " + employee.managerName
                  }
                  disabled={true}
                />
              )}
              {employee.employeeName && (
                <TextArea
                  id="assessmentDate"
                  autoSize={{ minRows: 1, maxRows: 1 }}
                  defaultValue={"Assessment Date :   " + date}
                  disabled={true}
                />
              )}
            </div>
          ) : (
            <div className="assessmentEmployee">
              {employee.employeeName && (
                <TextArea
                  id="employeeName"
                  autoSize={{ minRows: 1, maxRows: 1 }}
                  defaultValue={"Nome :    " + employee.employeeName}
                  disabled={true}
                />
              )}
              {employee.admissionDate && (
                <TextArea
                  id="admissionDate"
                  autoSize={{ minRows: 1, maxRows: 1 }}
                  defaultValue={"Data admissão :    " + employee.admissionDate}
                  disabled={true}
                />
              )}
              <div>
                <br />
              </div>
              {employee.managerName && (
                <TextArea
                  id="employeeManager"
                  autoSize={{ minRows: 1, maxRows: 1 }}
                  defaultValue={
                    "Nome do(a) responsável :   " + employee.managerName
                  }
                  disabled={true}
                />
              )}
              {employee.employeeName && (
                <TextArea
                  id="assessmentDate"
                  autoSize={{ minRows: 1, maxRows: 1 }}
                  defaultValue={"Data avaliação :    " + date}
                  disabled={true}
                />
              )}
            </div>
          )} */}
          {/* 
          <div className="backgroundAssessment">
            <br />
            <br />
            <br />
          </div> */}

          {/* <div className="assessmentFirstQuestion" style={{border:"1px red solid"}}>
            <div className="assessmentQuestion1">
              {firstMonthAssessmentQuestions[0] &&
                firstMonthAssessmentQuestions[0]
                  .firstMonthAssessmentQuestionName}
            </div>
          </div> */}

          {/* <div
            className="backgroundAssessment"
            style={{ border: "1px red solid" }}
          >
            <Row
              className="assessmentQuestionBorder"
              style={{ border: "1px green solid" }}
            >
              <Col>
                <div className="assessmentSatisfaction">
                  <label id="satisfaction">
                    {employee.isEmailEnglishLanguage
                      ? "Satisfaction With..."
                      : "Satisfação com..."}
                  </label>
                </div>
                <div className="assessmentSubQuestion">
                  {firstMonthAssessmentQuestions[0] &&
                    firstMonthAssessmentQuestions[3]
                      .firstMonthAssessmentQuestionName}
                </div>
                <div className="assessmentSubQuestion">
                  {firstMonthAssessmentQuestions[0] &&
                    firstMonthAssessmentQuestions[4]
                      .firstMonthAssessmentQuestionName}
                </div>
                <div className="assessmentSubQuestion">
                  {firstMonthAssessmentQuestions[0] &&
                    firstMonthAssessmentQuestions[5]
                      .firstMonthAssessmentQuestionName}
                </div>
                <div className="assessmentSubQuestion">
                  {firstMonthAssessmentQuestions[0] &&
                    firstMonthAssessmentQuestions[6]
                      .firstMonthAssessmentQuestionName}
                </div>
                <div className="assessmentSubQuestion">
                  {firstMonthAssessmentQuestions[0] &&
                    firstMonthAssessmentQuestions[7]
                      .firstMonthAssessmentQuestionName}
                </div>
              </Col>
              <Col>
                <div className="levelOfSatisfaction">
                  <label>
                    {employee.isEmailEnglishLanguage
                      ? "Level of satisfaction..."
                      : "Grau de satisfação..."}
                  </label>
                </div>
                <div className="response">
                  <Radio.Group
                    onChange={(e) => onChange(e, 3)}
                    value={values[3]}
                  >
                    <Radio value={1}>1</Radio>
                    <Radio value={2}>2</Radio>
                    <Radio value={3}>3</Radio>
                    <Radio value={4}>4</Radio>
                    <Radio value={5}>5</Radio>
                  </Radio.Group>
                </div>
                <div className="response">
                  <Radio.Group
                    onChange={(e) => onChange(e, 4)}
                    value={values[4]}
                  >
                    <Radio value={1}>1</Radio>
                    <Radio value={2}>2</Radio>
                    <Radio value={3}>3</Radio>
                    <Radio value={4}>4</Radio>
                    <Radio value={5}>5</Radio>
                  </Radio.Group>
                </div>
                <div className="response">
                  <Radio.Group
                    onChange={(e) => onChange(e, 5)}
                    value={values[5]}
                  >
                    <Radio value={1}>1</Radio>
                    <Radio value={2}>2</Radio>
                    <Radio value={3}>3</Radio>
                    <Radio value={4}>4</Radio>
                    <Radio value={5}>5</Radio>
                  </Radio.Group>
                </div>
                <div className="response">
                  <Radio.Group
                    onChange={(e) => onChange(e, 6)}
                    value={values[6]}
                  >
                    <Radio value={1}>1</Radio>
                    <Radio value={2}>2</Radio>
                    <Radio value={3}>3</Radio>
                    <Radio value={4}>4</Radio>
                    <Radio value={5}>5</Radio>
                  </Radio.Group>
                </div>
                <div className="response">
                  <Radio.Group
                    onChange={(e) => onChange(e, 7)}
                    value={values[7]}
                  >
                    <Radio value={1}>1</Radio>
                    <Radio value={2}>2</Radio>
                    <Radio value={3}>3</Radio>
                    <Radio value={4}>4</Radio>
                    <Radio value={5}>5</Radio>
                  </Radio.Group>
                </div>
                <div className="assessmentErrorMessage">
                  {messageError1 && <p>Please fill out all questions!</p>}
                </div>
              </Col>
              <div>
                <label className="assessmentLegend">
                  {employee.isEmailEnglishLanguage
                    ? "1 = Very Dissatisfied, 2 = Dissatisfied, 3 = Not Very Satisfied, 4 = Satisfied and 5 = Very Satisfied."
                    : "1 = Muito Insatisfeito, 2 = Insatisfeito, 3 = Pouco Satisfeito, 4 = Satisfeito e 5 = Muito Satisfeito."}
                </label>
              </div>
            </Row> 
          </div>
          */}

          {/* <div className="assessmentFirstQuestion">
            <div className="assessmentQuestion1">
              {firstMonthAssessmentQuestions[0] &&
                firstMonthAssessmentQuestions[1]
                  .firstMonthAssessmentQuestionName}
            </div>
          </div>
          <div className="backgroundAssessment">
            <Row className="assessmentQuestionBorder2">
              <Col>
                <div className="assessmentSatisfaction">
                  <label id="satisfaction">
                    {employee.isEmailEnglishLanguage
                      ? "Satisfaction With..."
                      : "Satisfação com..."}
                  </label>
                </div>
                <div className="assessmentSubQuestion">
                  {firstMonthAssessmentQuestions[0] &&
                    firstMonthAssessmentQuestions[8]
                      .firstMonthAssessmentQuestionName}
                </div>
                <div className="assessmentSubQuestion">
                  {firstMonthAssessmentQuestions[0] &&
                    firstMonthAssessmentQuestions[9]
                      .firstMonthAssessmentQuestionName}
                </div>
                <div className="assessmentSubQuestion">
                  {firstMonthAssessmentQuestions[0] &&
                    firstMonthAssessmentQuestions[10]
                      .firstMonthAssessmentQuestionName}
                </div>
                <div className="assessmentSubQuestion">
                  {firstMonthAssessmentQuestions[0] &&
                    firstMonthAssessmentQuestions[11]
                      .firstMonthAssessmentQuestionName}
                </div>
              </Col>
              <Col>
                <div className="levelOfSatisfaction">
                  <label>
                    {employee.isEmailEnglishLanguage
                      ? "Level of satisfaction..."
                      : "Grau de satisfação..."}
                  </label>
                </div>

                <div className="response">
                  <Radio.Group
                    onChange={(e) => onChange(e, 8)}
                    value={values[8]}
                  >
                    <Radio value={1}>1</Radio>
                    <Radio value={2}>2</Radio>
                    <Radio value={3}>3</Radio>
                    <Radio value={4}>4</Radio>
                    <Radio value={5}>5</Radio>
                  </Radio.Group>
                </div>
                <div className="response">
                  <Radio.Group
                    onChange={(e) => onChange(e, 9)}
                    value={values[9]}
                  >
                    <Radio value={1}>1</Radio>
                    <Radio value={2}>2</Radio>
                    <Radio value={3}>3</Radio>
                    <Radio value={4}>4</Radio>
                    <Radio value={5}>5</Radio>
                  </Radio.Group>
                </div>
                <div className="response">
                  <Radio.Group
                    onChange={(e) => onChange(e, 10)}
                    value={values[10]}
                  >
                    <Radio value={1}>1</Radio>
                    <Radio value={2}>2</Radio>
                    <Radio value={3}>3</Radio>
                    <Radio value={4}>4</Radio>
                    <Radio value={5}>5</Radio>
                  </Radio.Group>
                </div>
                <div className="response">
                  <Radio.Group
                    onChange={(e) => onChange(e, 11)}
                    value={values[11]}
                  >
                    <Radio value={1}>1</Radio>
                    <Radio value={2}>2</Radio>
                    <Radio value={3}>3</Radio>
                    <Radio value={4}>4</Radio>
                    <Radio value={5}>5</Radio>
                  </Radio.Group>
                </div>
                <div className="assessmentErrorMessage">
                  {messageError2 && <p>Please fill out all questions!</p>}
                </div>
              </Col>
              <div>
                <label className="assessmentLegend">
                  {employee.isEmailEnglishLanguage
                    ? "1 = Very Dissatisfied, 2 = Dissatisfied, 3 = Not Very Satisfied, 4 = Satisfied and 5 = Very Satisfied."
                    : "1 = Muito Insatisfeito, 2 = Insatisfeito, 3 = Pouco Satisfeito, 4 = Satisfeito e 5 = Muito Satisfeito."}
                </label>
              </div>
            </Row>
          </div> */}

          {/* <div className="assessmentFirstQuestion">
            <div className="assessmentQuestion1">
              {firstMonthAssessmentQuestions[0] &&
                firstMonthAssessmentQuestions[2]
                  .firstMonthAssessmentQuestionName}
            </div>
            <div className="backgroundAssessment">
              <div className="assessmentQuestionBorder"></div>
              <TextArea
                id="assessmentSugestions"
                autoSize={{ minRows: 10, maxRows: 10 }}
                onChange={(e) => onChange(e, 2)}
              />
            </div>

            <div>
              <label className="legendSugestions">
                {employee.isEmailEnglishLanguage
                  ? "*We stress that if you have any questions you can contact your manager or someone from the Human Capital Team"
                  : "*Reforçamos que para qualquer dúvida ou questão que tenhas poderás entrar em contacto com o/a teu/tua manager ou alguém da equipa de Recursos Humanos."}
              </label>
            </div>
          </div> */}

          {/* <div className="backgroundAssessment">
            <br />
            <br />
          </div> */}

          {/* <div className="backgroundAssessment">
            <div>
              <Button
                className="assessmentButton"
                type="submit"
                onClick={() => handleFinish()}
                style={{
                  backgroundColor: "#32EBD4",
                  color: "#0A2038",
                  border: "#32EBD4",
                }}
              >
                <SendOutlined />{" "}
                {employee.isEmailEnglishLanguage ? "Send" : "Enviar"}
              </Button>
            </div>
          </div> */}

          {/* <div className="backgroundAssessment">
            <label className="assessmentPolicy">
              {employee.isEmailEnglishLanguage
                ? "©Adentis. All rights reserved"
                : "©Adentis. Todos os direitos reservados"}
            </label>
          </div> */}
          {/* <div className="backgroundAssessment">
            <br />
            <br />
          </div> */}
        </div>
      )}
    </>
  );
}
